var _path, _ellipse, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8333 11.1906H17.5L15.8333 8.41278C15.8333 4.68705 12.8486 1.66675 9.16667 1.66675C5.48477 1.66675 2.5 4.68705 2.5 8.41278C2.5 10.5432 3.4759 12.4429 5 13.6792V18.3334H12.5V15.9525H12.8333C14.4902 15.9525 15.8333 14.6093 15.8333 12.9525V11.1906Z",
    fill: "url(#paint0_linear_21048_12921)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.16667,
    cy: 8.33342,
    rx: 4.16667,
    ry: 4.16667,
    fill: "#F7F7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1953 6.82086L8.65981 9.21328L7.56879 8.18382C7.36903 7.99532 7.03097 7.99532 6.81584 8.18382C6.61607 8.37231 6.61607 8.6913 6.81584 8.89429L8.27565 10.2718C8.38321 10.3733 8.50615 10.4167 8.64444 10.4167C8.78274 10.4167 8.92104 10.3733 9.01324 10.2718L11.9329 7.51684C12.1326 7.32834 12.1326 7.00935 11.9329 6.80636C11.7331 6.61786 11.395 6.61786 11.1953 6.82086Z",
    fill: "#908EF0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21048_12921",
    x1: 9.58333,
    y1: 10.0001,
    x2: 19.2842,
    y2: -0.422625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0002,
    stopColor: "#D2D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0003,
    stopColor: "#B1B0F5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHead);
export default __webpack_public_path__ + "static/media/head.2e43b3617d1d271894b38891e6c977bd.svg";
export { ForwardRef as ReactComponent };